import { ADD_FAV_ITEM, REMOVE_FAV_ITEM, SET_FAV_ITEMS } from "./types";

export const setFavItems = (data) => ({
  type: SET_FAV_ITEMS,
  data: data,
});

export const addFavItem = (data) => ({
  type: ADD_FAV_ITEM,
  data: data,
});

export const removeFavItem = (data) => ({
  type: REMOVE_FAV_ITEM,
  data: data,
});
